import { configureStore } from '@reduxjs/toolkit';
import authReducer from '../containers/User/AuthSlice';
import articleReducer from '../containers/Articles/ArticleSlice';
import articleTypeReducer from '../containers/Articles/ArticleTypeSlice';
import pageReducer from '../containers/Pages/PageSlice';

export const store = configureStore({
    reducer: {
        auth: authReducer,
        articles: articleReducer,
        articleTypes: articleTypeReducer,
        pages: pageReducer,
    },
});
